import Rails from '@rails/ujs';
import '../modules/bootstrap';
import '../modules/admin-navigation';
import '../modules/admin-school-content';
import '../modules/article-category';
import '../modules/course-progress';
import '../modules/date-converter';
import '../modules/iframe-size-to-content';
import '../modules/interactive-forms';
import '../modules/pagination';
import '../modules/school-switcher';
import '../modules/course-select';
import '../modules/teacher-dashboard';
import '../modules/textarea-character-count';
import '../modules/user-form';

if (!window.Rails) Rails.start();
